const PREFIX = 'admin.campaigns.submissions.reviewImages.errors';

const KNOWN_REVIEW_IMAGES_ERRORS = new Set([
  'invalid_rejection_images',
  'too_many_rejection_images',
  'invalid_reviewer_images',
  'too_many_reviewer_images',
]);

type ErrorLike = {
  message?: unknown;
  graphQLErrors?: ReadonlyArray<{ message?: unknown }> | null;
};

/** Returns the i18n key for a review-images backend error code, else null. */
export function mapReviewImagesError(err: ErrorLike | string | null | undefined): string | null {
  if (err == null) return null;
  const candidates: unknown[] =
    typeof err === 'string'
      ? [err]
      : [...(err.graphQLErrors ?? []).map((e) => e?.message), err.message];
  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const value = candidate.trim();
    if (KNOWN_REVIEW_IMAGES_ERRORS.has(value)) return `${PREFIX}.${value}`;
  }
  return null;
}
